import React from 'react';
import Layout from 'layout/Layout';
import PreviewingReservationCancelComponent from 'components/PreviewingReservationCancelComponent';

const PreviewingReservationCancelPage: React.FC = () => {
  const pageTitle = '予約のキャンセル';

  return (
    <Layout pageTitle={pageTitle}>
      <PreviewingReservationCancelComponent></PreviewingReservationCancelComponent>
    </Layout>
  );
};
export default PreviewingReservationCancelPage;
